module.exports = __webpack_public_path__ + "img/Saved-products-icon.db3e93a5.webp";